import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { approval_urge } from "@/api/apis";
import { ElMessage } from "element-plus";
export default {
  __name: 'approval-urge',
  props: ["origin_id", "approval_flow_id"],
  setup(__props) {
    var props = __props;
    var handleUrge = () => {
      approval_urge({
        origin_id: props.origin_id,
        approval_flow_id: props.approval_flow_id
      }, "post").then(res => {
        ElMessage.success("操作成功");
      });
    };
    return (_ctx, _cache) => {
      var _component_BaseButton = _resolveComponent("BaseButton");
      var _component_el_popconfirm = _resolveComponent("el-popconfirm");
      return _openBlock(), _createBlock(_component_el_popconfirm, {
        width: "200",
        title: "确定要催办此单据?",
        onConfirm: handleUrge
      }, {
        reference: _withCtx(() => [_createVNode(_component_BaseButton, {
          style: {
            "margin-right": "10px"
          },
          text: "催办",
          type: "expedite"
        })]),
        _: 1
      });
    };
  }
};